import {RouterView} from '@/routes/RouterView.js';

const InstructorStatus = _ => import(/* webpackChunkName: "js/split/InstructorStatus", webpackPreload: true */	'@/components/views/home/instructor/InstructorStatus');
const InstructorPlans = _ => import(/* webpackChunkName: "js/split/InstructorPlans", webpackPreload: true */	'@/components/views/home/instructor/InstructorPlans');
const InstructorEvaluations = _ => import(/* webpackChunkName: "js/split/InstructorEvaluations", webpackPreload: true */	'@/components/views/home/instructor/InstructorEvaluations');
const InstructorHistoricEvaluations = _ => import(/* webpackChunkName: "js/split/InstructorHistoricEvaluations", webpackPreload: true */	'@/components/views/home/instructor/InstructorHistoricEvaluations');
const InstructorViewTrainingPlan = _ => import(/* webpackChunkName: "js/split/InstructorViewTrainingPlan", webpackPreload: true */	'@/components/views/home/instructor/InstructorViewTrainingPlan');
const InstructorEvaluatesYoung = _ => import(/* webpackChunkName: "js/split/InstructorEvaluatesYoung", webpackPreload: true */	'@/components/views/home/instructor/InstructorEvaluatesYoung');
const InstructorYoungs = _ => import(/* webpackChunkName: "js/split/InstructorYoungs", webpackPreload: true */	'@/components/views/home/instructor/InstructorYoungs');
const YoungCompletedTraining = _ => import(/* WebpackChunkName: "js/split/YoungCompletedTraining", webpackPreload: true */ "@/components/views/home/instructor/YoungCompletedTraining.vue");

export default {
	path: '/instructor',
	component: RouterView,
	children: [
		{
			path: 'estatus',
			component:  InstructorStatus,
			name: 'InstructorStatus',
			meta:{
				auth: true
			}
		},
		{
			path: 'planes',
			component:  InstructorPlans,
			name: 'InstructorPlans',
			meta:{
				auth: true
			}
		},	
		{
			path: 'becarios',
			component:  InstructorYoungs,
			name: 'InstructorYoungs',
			meta:{
				auth: true
			}
		},				
		{
			path: 'evaluaciones',
			component:  InstructorEvaluations,
			name: 'InstructorEvaluations',
			meta:{
				auth: true
			}
		},		
		{
			path: 'historico-evaluaciones',
			component:  InstructorHistoricEvaluations,
			name: 'InstructorHistoricEvaluations',
			meta:{
				auth: true
			}
		},
		{
			path: 'plan-capacitacion/ver/:id',
			component:  InstructorViewTrainingPlan,
			name: 'InstructorViewTrainingPlan',
			props: true,
			meta:{
				auth: true
			}
		},

		{
			path: 'detalle-evaluacion/ver/:id',
			component:  InstructorEvaluatesYoung,
			name: 'InstructorEvaluatesYoung',
			meta:{
				auth: true
			}
		},
		{
            path: "becarios-con-capacitacion-concluida",
            component: YoungCompletedTraining,
            name: "YoungCompletedTraining",
            meta: {
                auth: true
            }
        }	



	],

}
